import { useGetList } from "ra-core";

export interface CallRecord {
  id: string;
  org_id: string;
  contact_id: string;
  twilio_call_sid: string;
  direction: "inbound" | "outbound";
  from_number: string;
  to_number: string;
  twilio_status: string;
  duration_seconds: number;
  recording_sid: string | null;
  recording_url: string | null;
  transcript: string | null;
  transcription_status: string;
  created_at: string;
}

export function useCallLog(contactId: string | undefined) {
  return useGetList<CallRecord>(
    "calls",
    {
      pagination: { page: 1, perPage: 50 },
      sort: { field: "created_at", order: "DESC" },
      filter: contactId ? { contact_id: contactId } : {},
    },
    { enabled: !!contactId }
  );
}
